var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAdd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add-square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3333 10.625H6.66667C6.325 10.625 6.04167 10.3417 6.04167 10C6.04167 9.65833 6.325 9.375 6.66667 9.375H13.3333C13.675 9.375 13.9583 9.65833 13.9583 10C13.9583 10.3417 13.675 10.625 13.3333 10.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 13.9583C9.65833 13.9583 9.375 13.675 9.375 13.3333V6.66667C9.375 6.325 9.65833 6.04167 10 6.04167C10.3417 6.04167 10.625 6.325 10.625 6.66667V13.3333C10.625 13.675 10.3417 13.9583 10 13.9583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.5 18.9583H7.5C2.975 18.9583 1.04167 17.025 1.04167 12.5V7.5C1.04167 2.975 2.975 1.04167 7.5 1.04167H12.5C17.025 1.04167 18.9583 2.975 18.9583 7.5V12.5C18.9583 17.025 17.025 18.9583 12.5 18.9583ZM7.5 2.29167C3.65833 2.29167 2.29167 3.65833 2.29167 7.5V12.5C2.29167 16.3417 3.65833 17.7083 7.5 17.7083H12.5C16.3417 17.7083 17.7083 16.3417 17.7083 12.5V7.5C17.7083 3.65833 16.3417 2.29167 12.5 2.29167H7.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4",
    opacity: 0
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAdd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add.4d3ceeb61d2dcc79b3680e6adce98d2b.svg";